import app from 'flarum/forum/app';
import Notification from 'flarum/forum/components/Notification';

export default class PrivateMessageNotification extends Notification {
  icon() { return 'fas fa-envelope'; }
  href() { return `${app.route('yingtaoMessages')}?conversation=${encodeURIComponent(this.attrs.notification.content().conversationId)}`; }
  content() { return app.translator.trans('yingtao-forum-homepage.forum.private_messages.new_message', { nickname: this.attrs.notification.content().senderNickname }); }
  excerpt() { return null; }
}
